var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "full_layout cart",
      attrs: { id: "cart" }
    },
    [
      _vm.list
        ? _c(
            "div",
            [
              _vm.addressList != null && _vm.list != null
                ? _c(
                    "div",
                    { staticClass: "cartTitle" },
                    [
                      _vm.userInfo.NationCode != "+86" ||
                      _vm.userInfo.MemberSource != "CN"
                        ? [
                            _c("el-alert", {
                              staticStyle: { "margin-bottom": "30px" },
                              attrs: {
                                title: _vm.$t("alertCustoms"),
                                type: "warning",
                                closable: false,
                                "show-icon": ""
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("SelectAddress"))),
                        _c("span", [
                          _vm._v(
                            "(" +
                              _vm._s(
                                _vm.$tc("CountItem", _vm.list.Details.length, {
                                  n: _vm.list.Details.length
                                })
                              ) +
                              ")"
                          )
                        ])
                      ])
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addressList != null
                ? _c(
                    "div",
                    [
                      _vm.dislogType.address
                        ? _c("to-address", {
                            attrs: {
                              title: _vm.title,
                              domVisible: _vm.dislogType.address,
                              list: _vm.addressItem,
                              isSet: _vm.isSet
                            },
                            on: { closeDialog: _vm.closeDialog }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "addressShow",
                          class: _vm.isAddShow ? "on" : ""
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "addressList" },
                            _vm._l(_vm.addressList, function(item, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  class: _vm.isAdd == index ? "on" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.setOnlyAddress(index, item)
                                    }
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("div", { staticClass: "addressName" }, [
                                      _vm._v(
                                        _vm._s(item.City) +
                                          " (" +
                                          _vm._s(item.UserName) +
                                          _vm._s(
                                            _vm.$i18n.locale === "zh"
                                              ? "收"
                                              : ""
                                          ) +
                                          ")"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "addressText line_txt2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("setProvice")(item.Provice)
                                          ) +
                                            " " +
                                            _vm._s(item.AddressDetail)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "addressPhone" }, [
                                      _vm._v(_vm._s(item.Email))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "addressPhone" }, [
                                      _vm._v(_vm._s(item.Mobile))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  item.IsDefault
                                    ? _c("span", { staticClass: "default" }, [
                                        _vm._v(_vm._s(_vm.$t("Default")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "setAddress",
                                      on: {
                                        click: function($event) {
                                          return _vm.setAddress(
                                            "address",
                                            1,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Edit")))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "setInfoBox space_between",
                          class: { addressShow: _vm.addressCount <= 0 }
                        },
                        [
                          _vm.addressCount > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "isShow",
                                  on: { click: _vm.IsShow }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isAddShow
                                        ? _vm.$t("Hide")
                                        : _vm.$t("ViewAllAddresses")
                                    )
                                  )
                                ]
                              )
                            : _c("div", { staticClass: "isShow" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "setinfo",
                              on: {
                                click: function($event) {
                                  return _vm.setAddress("address", 0)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("AddNewAddress")))]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.list.Details[0].Presale == 1 || _vm.list.OrderPresale == 1
                ? _c("div", { staticClass: "stageDetail" }, [
                    _c(
                      "div",
                      {
                        staticClass: "stageOne",
                        class:
                          (_vm.list.Details[0].Presale == 1 && !_vm.ischeck) ||
                          (_vm.ischeck && !_vm.list.IsPayDeposit)
                            ? "on"
                            : ""
                      },
                      [
                        _c("div", {}, [
                          _c("div", { staticClass: "stageRadius" }),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("Stage1")))]),
                          _vm._v(" "),
                          !_vm.ischeck
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.$t("PayDeposit")) + " "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "￥ " +
                                      _vm._s(
                                        _vm
                                          .priceCount(
                                            _vm.list.Details[0].AdvancePrice,
                                            _vm.list.Details[0].Num,
                                            "multi"
                                          )
                                          .toLocaleString()
                                      )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.ischeck
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.$t("PayDeposit")) + " "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "￥ " +
                                      _vm._s(
                                        _vm.list.AdvancePrice.toLocaleString()
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stageTwo",
                        class: { on: _vm.list.IsPayDeposit && _vm.ischeck }
                      },
                      [
                        _c("div", {}, [
                          _c("div", { staticClass: "stageRadius" }),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.$t("Stage2")))]),
                          _vm._v(" "),
                          !_vm.ischeck
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.$t("PayBalance")) + " "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "￥ " +
                                      _vm._s(
                                        _vm
                                          .priceCount(
                                            _vm.priceCount(
                                              _vm.list.Details[0].LowestPrice,
                                              _vm.list.Details[0].AdvancePrice,
                                              "sub"
                                            ),
                                            _vm.list.Details[0].Num,
                                            "multi"
                                          )
                                          .toLocaleString()
                                      )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.ischeck
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.$t("PayBalance")) + " "),
                                _c("span", { staticClass: "price" }, [
                                  _vm._v(
                                    "￥ " +
                                      _vm._s(
                                        _vm
                                          .priceCount(
                                            _vm.list.RealOrderPrice,
                                            _vm.list.AdvancePrice,
                                            "sub"
                                          )
                                          .toLocaleString()
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cart_list_title check_list cart_list" },
                [
                  _c("div", { staticClass: "cart_list_products" }, [
                    _vm._v(_vm._s(_vm.$t("Product")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart_list_detail" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart_list_price" }, [
                    _vm._v(_vm._s(_vm.$t("UnitPrice")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart_list_number" }, [
                    _vm._v(_vm._s(_vm.$t("Quantity")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart_list_total" }, [
                    _vm._v(_vm._s(_vm.$t("Total")))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.list != null
                ? _vm._l(_vm.list.Details, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "check_list cart_list" },
                      [
                        _c(
                          "div",
                          { staticClass: "cart_list_products" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "cart_img",
                                attrs: {
                                  to: {
                                    path: "/market/item/" + item._id + "?type=1"
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: item.TitImg + "?imageView2/2/w/160"
                                  }
                                }),
                                _vm._v(" "),
                                item.Presale == 1 || _vm.list.OrderPresale == 1
                                  ? _c(
                                      "span",
                                      { staticClass: "icon_presale" },
                                      [_vm._v(_vm._s(_vm.$t("PreSale")))]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cart_list_detail space_between" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    path: "/market/item/" + item._id + "?type=1"
                                  }
                                }
                              },
                              [_c("p", [_vm._v(_vm._s(item.Title))])]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !item.IsPoints || item.IsPoints < 1
                          ? _c("div", { staticClass: "cart_list_price" }, [
                              item.Price != item.LowestPrice
                                ? _c("del", [
                                    _vm._v(
                                      "￥ " +
                                        _vm._s(item.Price.toLocaleString())
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.Price == item.LowestPrice
                                ? _c("span", [
                                    _vm._v(
                                      "￥ " +
                                        _vm._s(item.Price.toLocaleString())
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.Price != item.LowestPrice
                                ? _c("span", { staticClass: "price_red" }, [
                                    _vm._v(
                                      "￥ " +
                                        _vm._s(
                                          item.LowestPrice.toLocaleString()
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.IsPoints == 1
                          ? _c("div", { staticClass: "cart_list_price" }, [
                              !_vm.ischeck
                                ? _c(
                                    "div",
                                    { staticClass: "cart_point_price" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.PointsScore) +
                                            " " +
                                            _vm._s(_vm.$t("Points"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.Price > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "+￥ " +
                                                _vm._s(
                                                  item.Price.toLocaleString()
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ischeck
                                ? _c(
                                    "div",
                                    { staticClass: "cart_point_price" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.PointsScore) +
                                            " " +
                                            _vm._s(_vm.$t("Points"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.Price > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "+￥ " +
                                                _vm._s(
                                                  item.Price.toLocaleString()
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "cart_list_number" }, [
                          _c("span", [_vm._v(_vm._s(item.Num))])
                        ]),
                        _vm._v(" "),
                        !item.IsPoints ||
                        (item.IsPoints < 1 && !_vm.ischeck) ||
                        (_vm.list.OrderPresale != 2 && _vm.ischeck)
                          ? _c("div", { staticClass: "cart_list_total" }, [
                              ((_vm.list.Details[0].Presale == 0 ||
                                _vm.list.Details[0].Presale == null) &&
                                !_vm.ischeck) ||
                              (_vm.list.OrderPresale != 1 && _vm.ischeck)
                                ? _c("span", [
                                    _vm._v(
                                      "￥ " +
                                        _vm._s(
                                          _vm
                                            .priceCount(
                                              item.LowestPrice,
                                              item.Num,
                                              "multi"
                                            )
                                            .toLocaleString()
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (item.Presale == 1 && !_vm.ischeck) ||
                              (_vm.ischeck &&
                                !_vm.list.IsPayDeposit &&
                                _vm.list.OrderPresale == 1)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "itemPresale",
                                      class: "lang-" + _vm.$i18n.locale
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(
                                          "￥ " +
                                            _vm._s(
                                              _vm.ischeck
                                                ? _vm.list.AdvancePrice.toLocaleString()
                                                : _vm
                                                    .priceCount(
                                                      _vm.list.Details[0]
                                                        .AdvancePrice,
                                                      _vm.list.Details[0].Num,
                                                      "multi"
                                                    )
                                                    .toLocaleString()
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      !_vm.ischeck
                                        ? _c("span", {}, [
                                            _vm._v(
                                              "( " +
                                                _vm._s(_vm.$t("Balance")) +
                                                " ￥ " +
                                                _vm._s(
                                                  _vm
                                                    .priceCount(
                                                      _vm.priceCount(
                                                        _vm.list.Details[0]
                                                          .LowestPrice,
                                                        _vm.list.Details[0]
                                                          .AdvancePrice,
                                                        "sub"
                                                      ),
                                                      _vm.list.Details[0].Num,
                                                      "multi"
                                                    )
                                                    .toLocaleString()
                                                ) +
                                                " )"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.ischeck
                                        ? _c("span", [
                                            _vm._v(
                                              "( " +
                                                _vm._s(_vm.$t("Balance")) +
                                                " ￥ " +
                                                _vm._s(
                                                  _vm
                                                    .priceCount(
                                                      _vm.list.RealOrderPrice,
                                                      _vm.list.AdvancePrice,
                                                      "sub"
                                                    )
                                                    .toLocaleString()
                                                ) +
                                                " )"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.list.IsPayDeposit && _vm.ischeck
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "itemPresale PayDeposit",
                                      class: "lang-" + _vm.$i18n.locale
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(
                                          "￥ " +
                                            _vm._s(
                                              _vm.list.RealOrderPrice.toLocaleString()
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {}, [
                                        _vm._v(
                                          "( " +
                                            _vm._s(_vm.$t("Deposit")) +
                                            " ￥ " +
                                            _vm._s(
                                              _vm.list.AdvancePrice.toLocaleString()
                                            ) +
                                            " )"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        (item.IsPoints == 1 && !_vm.ischeck) ||
                        (_vm.list.OrderPresale == 2 && _vm.ischeck)
                          ? _c("div", { staticClass: "cart_list_total" }, [
                              !_vm.ischeck
                                ? _c(
                                    "div",
                                    { staticClass: "cart_point_price" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceCount(
                                              item.PointsScore,
                                              _vm.list.Details[0].Num,
                                              "multi"
                                            )
                                          ) +
                                            " " +
                                            _vm._s(_vm.$t("Points"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.Price > 0
                                        ? _c("div", [
                                            _vm._v(
                                              "+￥ " +
                                                _vm._s(
                                                  _vm
                                                    .priceCount(
                                                      item.Price,
                                                      _vm.list.Details[0].Num,
                                                      "multi"
                                                    )
                                                    .toLocaleString()
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.ischeck
                                ? _c(
                                    "div",
                                    { staticClass: "cart_point_price" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(item.TotalPoints) +
                                            " " +
                                            _vm._s(_vm.$t("Points"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.TotalPrice > 0
                                        ? _c("div", [
                                            _vm._v(
                                              "+￥ " +
                                                _vm._s(
                                                  item.TotalPrice.toLocaleString()
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.list != null
                ? _c("div", { staticClass: "subTotalBox" }, [
                    ((_vm.list.Details[0].Presale == 0 ||
                      _vm.list.Details[0].Presale == null) &&
                      _vm.list.Details[0].IsPoints != 1 &&
                      !_vm.ischeck) ||
                    (_vm.list.OrderPresale != 1 &&
                      _vm.ischeck &&
                      _vm.list.OrderPresale != 2)
                      ? _c(
                          "div",
                          { staticClass: "subTotal" },
                          [
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Total")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(_vm.countOrder(_vm.list.Details, 0))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Quantity")))]),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(
                                  _vm._s(_vm.countOrder(_vm.list.Details, 3))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.countOrder(_vm.list.Details, 2) > 0
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Discount")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price price_red" },
                                    [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.countOrder(_vm.list.Details, 2)
                                          )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.DiscountPrice > 0
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("StaffDiscount")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price price_red" },
                                    [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.list.DiscountPrice.toLocaleString()
                                          )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between total" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Subtotal")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ischeck
                                      ? _vm.list.OrderPrice.toLocaleString()
                                      : _vm.countOrder(_vm.list.Details, 1)
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "subtn",
                                attrs: {
                                  disabled:
                                    _vm.addressList != null
                                      ? _vm.disabled
                                      : true,
                                  type: "primary"
                                },
                                on: { click: _vm.createOrder }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    !_vm.ischeck ? "Submit order" : "Pay now"
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.list.Details[0].Presale == 1 &&
                      _vm.list.Details[0].IsPoints != 1) ||
                    _vm.list.OrderPresale == 1
                      ? _c(
                          "div",
                          { staticClass: "subTotal" },
                          [
                            (_vm.list.Details[0].Presale == 1 &&
                              !_vm.ischeck) ||
                            (_vm.ischeck && !_vm.list.IsPayDeposit)
                              ? _c(
                                  "div",
                                  { staticClass: "space_between total" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("PayDeposit")))
                                    ]),
                                    _vm._v(" "),
                                    !_vm.ischeck
                                      ? _c("span", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .priceCount(
                                                  _vm.list.Details[0]
                                                    .AdvancePrice,
                                                  _vm.list.Details[0].Num,
                                                  "multi"
                                                )
                                                .toLocaleString()
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.ischeck
                                      ? _c("span", { staticClass: "price" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.list.AdvancePrice.toLocaleString()
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.IsPayDeposit
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [_vm._v(_vm._s(_vm.$t("Total")))]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countOrder(_vm.list.Details, 0)
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.IsPayDeposit
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Quantity")))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.countOrder(_vm.list.Details, 3)
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.IsPayDeposit
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Discount")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price price_red" },
                                    [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.countOrder(_vm.list.Details, 2)
                                          )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.DiscountPrice > 0
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("StaffDiscount")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price price_red" },
                                    [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.list.DiscountPrice.toLocaleString()
                                          )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.IsPayDeposit
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Deposit")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price price_red" },
                                    [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.list.AdvancePrice.toLocaleString()
                                          )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ischeck && _vm.list.IsPayDeposit
                              ? _c(
                                  "div",
                                  { staticClass: "space_between total" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("Subtotal")))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .priceCount(
                                              _vm.list.RealOrderPrice,
                                              _vm.list.AdvancePrice,
                                              "sub"
                                            )
                                            .toLocaleString()
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "subtn",
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "primary"
                                },
                                on: { click: _vm.createOrder }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      (_vm.list.Details[0].Presale == 1 &&
                                        !_vm.ischeck) ||
                                        (_vm.ischeck && !_vm.list.IsPayDeposit)
                                        ? _vm.$t("PayDeposit")
                                        : _vm.$t("PayBalance")
                                    ) +
                                    "\n        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "space_between orderPresale" },
                              [
                                _c("span", { staticClass: "textPresale" }, [
                                  _vm._v(_vm._s(_vm.$t("verify.FinalPayment")))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.list.Details[0].IsPoints == 1 && !_vm.ischeck
                      ? _c(
                          "div",
                          { staticClass: "subTotal" },
                          [
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Points")))]),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceCount(
                                      _vm.list.Details[0].PointsScore,
                                      _vm.list.Details[0].Num,
                                      "multi"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("Points"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.list.Details[0].Price > 0 && !_vm.ischeck
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("UnitPrice")))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .priceCount(
                                            _vm.list.Details[0].Price,
                                            _vm.list.Details[0].Num,
                                            "multi"
                                          )
                                          .toLocaleString()
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Shipping")))]),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(_vm._s(_vm.$t("PayonDelivery")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between total" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Subtotal")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "total_point" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceCount(
                                      _vm.list.Details[0].PointsScore,
                                      _vm.list.Details[0].Num,
                                      "multi"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("Points")) +
                                    " "
                                ),
                                _vm.list.Details[0].Price > 0 && !_vm.ischeck
                                  ? _c("i", [
                                      _vm._v(
                                        "+ ￥ " +
                                          _vm._s(
                                            _vm
                                              .priceCount(
                                                _vm.list.Details[0].Price,
                                                _vm.list.Details[0].Num,
                                                "multi"
                                              )
                                              .toLocaleString()
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "subtn",
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "primary"
                                },
                                on: { click: _vm.createOrder }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    !_vm.ischeck
                                      ? _vm.$t("Submit")
                                      : _vm.$t("Pay")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.list.OrderPresale == 2 && _vm.ischeck
                      ? _c(
                          "div",
                          { staticClass: "subTotal" },
                          [
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Points")))]),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(
                                  _vm._s(_vm.list.RealPoints) +
                                    " " +
                                    _vm._s(_vm.$t("Points"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.list.RealOrderPrice > 0
                              ? _c("div", { staticClass: "space_between" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("UnitPrice")))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {}, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.list.RealOrderPrice.toLocaleString()
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Shipping")))]),
                              _vm._v(" "),
                              _c("span", {}, [
                                _vm._v(_vm._s(_vm.$t("PayonDelivery")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "space_between total" }, [
                              _c("span", [_vm._v(_vm._s(_vm.$t("Subtotal")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "total_point" }, [
                                _vm._v(
                                  _vm._s(_vm.list.RealPoints) +
                                    " " +
                                    _vm._s(_vm.$t("Points")) +
                                    " "
                                ),
                                _vm.list.RealOrderPrice > 0
                                  ? _c("i", [
                                      _vm._v(
                                        "+ ￥ " +
                                          _vm._s(
                                            _vm.list.RealOrderPrice.toLocaleString()
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "subtn",
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "primary"
                                },
                                on: { click: _vm.createOrder }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    !_vm.ischeck
                                      ? _vm.$t("Submit")
                                      : _vm.$t("Pay")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "span" }, [_c("i")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "span" }, [_c("i")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68767ad1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68767ad1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pay/checkout.vue
// module id = null
// module chunks = 